import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    comments: [],
    documents: [],
  },
  getters: {
    getComments(state) {
      return state.comments;
    },
    getDocuments(state) {
      return state.documents;
    },
  },
  mutations: {
    addComment(state, data) {
      state.comments.push(data);
    },
    addDocument(state, data) {
      state.documents.push(data);
    },
    removeDocument(state, id) {
      const i = state.documents.findIndex((a) => a.id === id);
      state.documents.splice(i, 1);
    },
    setDocument(state, data) {
      const i = state.documents.findIndex((a) => a.id === data.id);
      state.documents[i] = data;
    },
    setComments(state, data) {
      state.comments = data;
    },
    setDocuments(state, data) {
      state.documents = data;
    },
  },
  actions: {
    async createComment(state, { data, document, profile }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("documents")
        .doc(document)
        .collection("comments")
        .add(data);
      state.commit("addComment", data);
    },
    async createDocument(state, { comment, data, profile }) {
      const path = `${profile}/documents/${data.file.name}`;
      const ref = firebase.storage.ref().child(path);
      await ref.put(data.file);
      data = {
        file: {
          name: data.file.name,
          path: await ref.getDownloadURL(),
          size: data.file.size,
          type: data.file.name.split(".")[1]
        },
        created: data.created,
        createdBy: data.createdBy
      };

      const document = await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("documents")
        .add({ file: data.file, createdBy: data.createdBy });
      await document.update({ id: document.id });

      if (comment) {
        await state.dispatch("createComment", {
          data: {
            body: comment,
            createdBy: data.createdBy
          },
          document: document.id,
          profile,
        });
      }

      state.commit("addDocument", data);
    },
    async deleteDocument(state, { profile, document }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("documents")
        .doc(document)
        .delete();
      state.commit("removeDocument", document);
    },
    async listComments(state, { profile, document }) {
      let comments = [];
      const refs = await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("documents")
        .doc(document)
        .collection("comments")
        .get();
      refs.forEach((ref) => comments.push(ref.data()));
      state.commit("setComments", comments);
    },
    async listDocuments(state, id) {
      let documents = [];
      const refs = await firebase.db
        .collection("profiles")
        .doc(id)
        .collection("documents")
        .get();
      refs.forEach((ref) => documents.push(ref.data()));
      state.commit("setDocuments", documents);
    },
    async updateDocument(state, { data, profile, document }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("documents")
        .doc(document)
        .update(data);
      state.commit("setDocument", data);
    },
  },
};
